import { useEffect } from 'react';

function Lightbox({ photos, activeIndex, onClose, onChange }) {
  useEffect(() => {
    if (activeIndex === null) return undefined;

    document.body.style.overflow = 'hidden';

    const handleKey = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowLeft') onChange(activeIndex - 1);
      if (event.key === 'ArrowRight') onChange(activeIndex + 1);
    };

    window.addEventListener('keydown', handleKey);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [activeIndex, onClose, onChange]);

  if (activeIndex === null) {
    return null;
  }

  const hasPrev = activeIndex > 0;
  const hasNext = activeIndex < photos.length - 1;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/95 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Просмотр фото"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Закрыть"
        className="absolute right-4 top-4 z-10 cursor-pointer border-0 bg-transparent p-2 text-3xl leading-none text-white transition-opacity hover:opacity-60 md:right-6 md:top-6"
      >
        ×
      </button>

      {hasPrev && (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onChange(activeIndex - 1);
          }}
          aria-label="Предыдущее фото"
          className="absolute left-2 top-1/2 z-10 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-3 text-white transition-opacity hover:opacity-60 md:left-6"
        >
          ←
        </button>
      )}

      <img
        src={photos[activeIndex]}
        alt=""
        className="max-h-full max-w-full object-contain"
        onClick={(event) => event.stopPropagation()}
      />

      {hasNext && (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onChange(activeIndex + 1);
          }}
          aria-label="Следующее фото"
          className="absolute right-2 top-1/2 z-10 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-3 text-white transition-opacity hover:opacity-60 md:right-6"
        >
          →
        </button>
      )}
    </div>
  );
}

export default Lightbox;
